import { FC, memo, useCallback } from 'react';

import {
  IModifierMultiplier,
  ModifierType,
} from 'features/menu/components/product-detail/modifier/types';

import { ProductCardModifier } from 'components/product-card/modifier';
import { useMenuCalories } from 'hooks/menu/use-menu-calories';

export interface IRadioCheckListOption {
  label?: string;
  labelSuffix?: string;
  value: string;
}

export interface IModifierListItemProps {
  content: {
    name: string;
    image?: string;
    type?: ModifierType;
  };
  selectedOption?: string;
  onCardPress?: (value: IModifierMultiplier) => void;
  itemValue: IModifierMultiplier;
  options?: IRadioCheckListOption[];
  onOptionPress?: (itemValue: IModifierMultiplier, optionValue: string) => void;
  isSelected?: boolean;
  multipleChoiceQuantity?: boolean;
}

export const ModifierListItem: FC<IModifierListItemProps> = memo(
  ({
    content,
    isSelected = false,
    selectedOption,
    options,
    onCardPress,
    itemValue,
    onOptionPress: onOptionPressProp,
    multipleChoiceQuantity = false,
  }) => {
    const { formatCalories } = useMenuCalories();

    const calories = formatCalories(itemValue?.nutrition?.calories?.def ?? 0);
    const price = itemValue?.price;

    const onProductPress = useCallback(() => {
      onCardPress?.(itemValue);
    }, [itemValue, onCardPress]);

    const onOptionPress = useCallback(
      (value: any) => {
        onOptionPressProp?.(itemValue, value);
      },
      [onOptionPressProp, itemValue]
    );

    return (
      <ProductCardModifier
        isSelected={isSelected}
        onCardPress={onProductPress}
        selectedOption={selectedOption}
        options={options}
        onOptionPress={onOptionPress}
        multipleChoiceQuantity={multipleChoiceQuantity}
        productProps={{
          name: content.name,
          image: content.image,
          calories,
          price,
        }}
        imgObjectFitContain
      />
    );
  }
);
